import { Box, Typography, Paper } from "@mui/material";
import { colors } from "../../../ui/colors";
import { InfoItem, InfoSection } from "../../components/SectionInformation";

export const ReviewInformationForm = ({ formData, handleEditStepper }) => {
  const { firstName, lastName, alias, email, phone, countryCode, age, mailingAddress, workAs, individualIndustry } = formData;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h6"
        sx={{
          mb: 3,
          ml: { xs: 1, md: 3 },
          color: colors.gray.base,
          fontWeight: 600,
          fontSize: { xs: "18px", md: "20px" },
        }}
      >
        Take a quick look: is everything right?
      </Typography>

      {/* Account Section */}
      <InfoSection title="Account Information" onEdit={() => handleEditStepper(0)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 3 },
            mb: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <InfoItem label="First Name*" value={firstName} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Last Name*" value={lastName} />
          </Box>
        </Box>

        <InfoItem label="Alias" value={alias} />
        <InfoItem label="Email*" value={email} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 3 },
            mb: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Country Code*" value={countryCode} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Phone*" value={phone} />
          </Box>
        </Box>
      </InfoSection>

      {/* Personal Details Section */}
      <InfoSection title="Personal Information" onEdit={() => handleEditStepper(1)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 3 },
            mb: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Age" value={age} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Role / Work As*" value={workAs} />
          </Box>
        </Box>

        <Box sx={{ mb: 2 }}>
          <InfoItem label="Mailing Address*" value={mailingAddress} />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <InfoItem label="Industry*" value={individualIndustry} />
          </Box>
        </Box>
      </InfoSection>
    </Box>
  );
};
